export const SearchCategory = {
  products: "products",
  recipes: "recipes",
  jobs: "jobs",
  locations: "locations",
  topics: "topics",
} as const;
export type SearchCategory = (typeof SearchCategory)[keyof typeof SearchCategory];
